import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, ArrowRight } from 'lucide-react';
import { DEMO_PREREQS } from '../data/demoCampaignSteps';

const PREREQ_KEY = 'demo_campaign_prereqs';

export const PrereqChecklist = () => {
  const [checked, setChecked] = useState(() => {
    try { return JSON.parse(localStorage.getItem(PREREQ_KEY)) || {}; } catch { return {}; }
  });

  const toggle = (id) => {
    const next = { ...checked, [id]: !checked[id] };
    setChecked(next);
    localStorage.setItem(PREREQ_KEY, JSON.stringify(next));
  };

  const readyCount = DEMO_PREREQS.filter((p) => checked[p.id]).length;

  return (
    <div className="rounded-xl border border-orange/40 bg-card-bg p-5" data-testid="platform-prereq-checklist">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <h3 className="text-white font-bold text-xl">You'll need these {DEMO_PREREQS.length} things before your first campaign</h3>
        <span className="text-xs font-bold text-orange" data-testid="prereq-progress">{readyCount} of {DEMO_PREREQS.length} ready</span>
      </div>
      <div className="space-y-3">
        {DEMO_PREREQS.map((p) => (
          <label key={p.id} className="flex items-start gap-3 cursor-pointer group" data-testid={`prereq-item-${p.id}`}>
            <input
              type="checkbox"
              data-testid={`prereq-check-${p.id}`}
              checked={!!checked[p.id]}
              onChange={() => toggle(p.id)}
              className="mt-1 w-4 h-4 accent-lime shrink-0"
            />
            <span className="text-sm text-light-gray group-hover:text-white">
              {p.label}
              {p.internalLink && (
                <>
                  {' '}<Link to={p.internalLink} data-testid={`prereq-link-${p.id}`} className="text-lime hover:underline inline-flex items-center gap-1 font-bold" onClick={(e) => e.stopPropagation()}>
                    {p.internalLinkText} <ArrowRight size={11} />
                  </Link>
                </>
              )}
              {p.helpLink && (
                <>
                  {' '}<span className="text-gray">{p.help}</span>{' '}
                  <a href={p.helpLink} target="_blank" rel="noopener noreferrer" className="text-orange hover:underline inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                    {p.helpLinkText} <ExternalLink size={11} />
                  </a>
                </>
              )}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};
